function doAnnouncementBarV2() {
  if (customElements.get("announcement-bar-v2")) return null;

  class AnnouncementBarV2 extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector(".announcementBarV2Slider");
      this.sliderDelayTimer = this.dataset.sliderDelayTimer;
      this.dataToHide = this.dataset.pagesToHide;
      this.init();
    }
    init() {
      this.executeSwiper();
      this.pagesToHide();
    }

    executeSwiper() {
      if (this.sliderElement == null) return;
      const delayTimer = this.isStringNumber(this.sliderDelayTimer) ?? 5;
      const delay = delayTimer * 1000;
      const swiper = new Swiper(this.sliderElement, {
        direction: "horizontal",
        loop: false,
        autoHeight: false,
        slidesPerView: 1,
        autoplay: {
          delay,
        },
      });
    }

    isStringNumber(str) {
      if (!str) return false;
      const number = parseFloat(str);
      return !isNaN(number) ? number : false;
    }

    pagesToHide() {
      if (this.dataToHide == "false") return null;
      const pages = this.dataToHide.split(",");
      const currentPath = window.location.pathname;
      if (!pages.includes(currentPath.slice(1))) return null;
      this.classList.add("hide");
    }
  }
  customElements.define("announcement-bar-v2", AnnouncementBarV2);
}
doAnnouncementBarV2();
